import React, {useState} from "react";
import "./product-settings.css";
import {useDispatch, useSelector} from "react-redux";
import {MdModeEdit} from "react-icons/md";
import CategoryModal from "./components/CategoryModal";
import axios from "axios";
import {toast} from "react-toastify";
import {fetchCategory} from "../../../../_apis/api";
import {quickClone} from "../../../../_helpers/commonFunctions";
import {newCategoryInitialValue} from "../../../../_reducers/DataPanel/Products/productCategorySlice";
import {FaRegTrashAlt} from "react-icons/fa";
import DeleteModal from "../../../primer/POPUP-COMPONENTS/Delete-Modal/deleteModal";
import {Button, Col, Row} from "react-bootstrap";
import LogTable from "../../../primer/LogTable";
import {useTranslation} from "../../../../hooks/useTranslation";

export const ProductSettings = () => {
    const dispatch = useDispatch();
    const company = useSelector(state => state.COMPANY_DATA.company);
    const categories = useSelector((state) => state.PRODUCTS_CATEGORY.categories);
    const subCategories = useSelector((state) => state.PRODUCTS_CATEGORY.subCategories);

    const [openSubCategories, setOpenSubCategories] = useState([]); // Array of ids

    const [modalType, setModalType] = useState("new");
    const [categoryType, setCategoryType] = useState("category");
    const [defaultObject, setDefaultObject] = useState({});
    const [show, setShow] = useState(false);

    const [showDeleteModal, setShowDeleteModal] = useState(false);
    const [toBeDeleted, setToBeDeleted] = useState("");

    const renderSubCategoryRow = (cat, idx) => {
        const compArr = [];
        if (openSubCategories.includes(cat._id)) {
            const subCats = subCategories.filter((el) => el.parentCategory === cat._id);
            if (subCats.length > 0) {
                subCats.forEach((subCat, idx2) => {
                    compArr.push(
                        <tr className={"subCategory"} key={`ct-${idx}-${idx2}`} style={{cursor: "pointer"}} onClick={(e) => {
                            e.stopPropagation();
                            openSubCategoryEdit(subCat);
                        }}>
                            <td></td>
                            <td>{subCat.title}</td>
                            <td></td>
                            <td>
                                <div className={"product-settings-button product-settings-edit-style"} title={"Επεξεργασία"} onClick={(e) => {
                                    e.stopPropagation();
                                    openSubCategoryEdit(subCat);
                                }}>
                                    <MdModeEdit size={22} />
                                </div>
                                <div className={"product-settings-button product-settings-delete-style"} title={"Διαγραφή"} onClick={(e) => {
                                    e.stopPropagation();
                                    setToBeDeleted(subCat._id);
                                    setCategoryType("subCategory");
                                    setShowDeleteModal(true);
                                }}>
                                    <FaRegTrashAlt size={22} />
                                </div>
                            </td>
                        </tr>
                    )
                })
            }
            compArr.push(
                <tr key={`ct-${idx}`}>
                    <td colSpan={4} style={{
                        textDecoration: "underline",
                        textDecorationStyle: "dotted",
                        cursor: "pointer",
                        backgroundColor: "lightyellow",
                    }} onClick={() => openSubCategoryNew(cat)}>+ Δημιουργία νέας υποκατηγορίας στην κατηγορία {cat.title}</td>
                </tr>
            )
        }
        return compArr;
    }

    const toggleSubCategories = (cat) => {
        if (openSubCategories.includes(cat._id)) {
            setOpenSubCategories(openSubCategories.filter((el) => el !== cat._id));
        } else {
            setOpenSubCategories([...openSubCategories, cat._id]);
        }
    }

    const toggleAllSubCategories = () => {
        if (openSubCategories.length === categories.length) {
            setOpenSubCategories([]);
        } else {
            setOpenSubCategories(categories.map((o) => o._id));
        }
    }

    const openCategoryNew = () => {
        setModalType("new");
        setCategoryType("category");
        setDefaultObject({
            ...newCategoryInitialValue,
            mydata: [],
            taxes: {},
        });
        setShow(true);
    }

    const openSubCategoryNew = (parentCategory) => {
        setModalType("new");
        setCategoryType("subCategory");
        let mydata;
        try { mydata = JSON.parse(parentCategory.mydata) } catch { mydata = [] }
        let taxes;
        try { taxes = JSON.parse(parentCategory.taxes) } catch { taxes = {} }
        const prepObj = {
            ...newCategoryInitialValue,
            parentCategory: parentCategory._id,
            mydata,
            taxes,
        }
        const inheritKeys = ["accountingCode", "netAmountAccountingCode", "vatAccountingCode", "taxAccountCode", "accountingNonDeductibleVAT",
            "accountingCodeSales", "netAmountAccountingCodeSales", "vatAccountingCodeSales", "taxAccountCodeSales",
            "accountingCodeBuys", "netAmountAccountingCodeBuys", "vatAccountingCodeBuys", "taxAccountCodeBuys"
        ]
        for (const key of inheritKeys) prepObj[key] = parentCategory[key];
        setDefaultObject(prepObj);
        setShow(true);
    }

    const openCategoryEdit = (cat) => {
        setModalType("edit");
        setCategoryType("category");
        let mydata;
        try { mydata = JSON.parse(cat.mydata) } catch { mydata = [] }
        let taxes;
        try { taxes = JSON.parse(cat.taxes) } catch { taxes = {} }
        setDefaultObject({
            ...cat,
            mydata,
            taxes,
        });
        setShow(true);
    }

    const openSubCategoryEdit = (subCat) => {
        setModalType("edit");
        setCategoryType("subCategory");
        let mydata;
        try { mydata = JSON.parse(subCat.mydata) } catch { mydata = [] }
        let taxes;
        try { taxes = JSON.parse(subCat.taxes) } catch { taxes = {} }
        setDefaultObject({
            ...subCat,
            mydata,
            taxes,
        });
        setShow(true);
    }

    const closeModal = () => {
        setModalType("new");
        setCategoryType("category");
        setDefaultObject({});
        setShow(false);
    }

    const onModalAction = (obj) => {
        const cloneIt = quickClone(obj);
        cloneIt.mydata = JSON.stringify(cloneIt.mydata);
        cloneIt.taxes = JSON.stringify(cloneIt.taxes);
        axios.post(`${process.env.REACT_APP_API_URL2}/category/action`, {
            modalType,
            categoryType,
            company: company.id,
            data: cloneIt,
        }, {
            headers: { "Content-Type": "application/json" },
        }).then((res) => {
            if (res.data.status === "200") {
                toast.success("Επιτυχής αποθήκευση.");
                closeModal();
                dispatch(fetchCategory({company: company.id, isActive: "active"}));
            } else {
                toast.error(res.data.message);
            }
        }).catch((err) => {
            console.log(err);
            toast.error("Σφάλμα κατά την αποστολή αιτήματος.");
        })
    }

    return (
        <React.Fragment>
            <Row className={"mb-2"}>
                <Col md={12} className={"d-flex justify-content-end"}>
                    <Button onClick={() => openCategoryNew()}>+ Δημιουργία κατηγορίας</Button>
                </Col>
            </Row>
            <Row>
                <Col md={12}>
                    <table className={"product-settings-table mb-3"}>
                        <colgroup>
                            <col span={1} style={{width: "5%"}}></col>
                            <col span={1} style={{width: "40%"}}></col>
                            <col span={1} style={{width: "40%"}}></col>
                            <col span={1} style={{width: "20%"}}></col>
                        </colgroup>
                        <thead>
                        <tr>
                            <th style={{cursor: "pointer", userSelect: "none", fontWeight: "600"}} title={"Προβολή Υποκατηγοριών"} onClick={(e) => {
                                e.stopPropagation();
                                toggleAllSubCategories();
                            }}>
                                {openSubCategories.length === categories.length ? "-" : "+"}
                            </th>
                            <th>Τίτλος</th>
                            <th>Πρόθεμα</th>
                            <th>Ενέργειες</th>
                        </tr>
                        </thead>
                        <tbody>
                        {categories.map((cat, idx) => (
                            <React.Fragment>
                                <tr key={`ct-${idx}`} style={{cursor: "pointer"}} onClick={() => openCategoryEdit(cat)}>
                                    <td style={{cursor: "pointer", userSelect: "none", fontWeight: "600"}} title={"Προβολή Υποκατηγοριών"} onClick={(e) => {
                                        e.stopPropagation();
                                        toggleSubCategories(cat);
                                    }}>
                                        {openSubCategories.includes(cat._id) ? "-" : "+"}
                                    </td>
                                    <td style={{fontWeight: "600"}}>{cat.title}</td>
                                    <td>{cat.maskCode}</td>
                                    <td>
                                        <div className={"product-settings-button product-settings-edit-style"} title={"Επεξεργασία"} onClick={(e) => {
                                            e.stopPropagation();
                                            openCategoryEdit(cat)
                                        }}>
                                            <MdModeEdit size={22} />
                                        </div>
                                        <div className={"product-settings-button product-settings-delete-style"} title={"Διαγραφή"} onClick={(e) => {
                                            e.stopPropagation();
                                            setToBeDeleted(cat._id);
                                            setCategoryType("category");
                                            setShowDeleteModal(true);
                                        }}>
                                            <FaRegTrashAlt size={22} />
                                        </div>
                                    </td>
                                </tr>
                                {renderSubCategoryRow(cat)}
                            </React.Fragment>
                        ))}
                        </tbody>
                    </table>
                </Col>
            </Row>

            <CategoryModal
                modalType={modalType}
                categoryType={categoryType}
                show={show}
                setShow={setShow}
                defaultObject={defaultObject}
                callbackFunction={onModalAction}
            />

            <DeleteModal
                showDelete={showDeleteModal}
                showDeleteModal={setShowDeleteModal}
                toBeDeleted={toBeDeleted}
                tableName={categoryType === "category" ? "Product Category" : "Product Subcategory"}
                updateFunction={() => {
                    dispatch(fetchCategory({company: company.id, isActive: "active"}));
                }}
            />
        </React.Fragment>
    )
}

export const ProductSettingsLog = () => {
    const {t} = useTranslation();

    return (
        <React.Fragment>
            <div className="text-muted mb-2"><i>{t('Logs.productCategoryLog')}</i></div>
            <LogTable model="productCategory"/>
        </React.Fragment>
    )
}
